import { FC } from "react"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { useIsOrgAdmin } from "../../hooks/useIsOrgAdmin"
import { ROUTES } from "../../hooks/useNavigation"
import { useSession } from "../../hooks/useSession"
import { loggingOutState, currentRiskAlertPathState } from "../../utils/store"
import ForgotPassword from "./ForgotPassword"
import ForgotPasswordSuccess from "./ForgotPasswordSuccess"
import LoggedOut from "./LoggedOut"
import Login from "./Login"
import ResetPasswordSuccess from "./PasswordResetSuccess"
import ResetPasswordSuccessMobile from "./PasswordResetSuccessMobile"
import Register from "./Register"
import ResetPassword from "./ResetPassword"
import { PrivateRoutes } from "./PrivateRoutes"
import IdleLogout from "../organisms/IdleLogout"
import { useSetRecoilState } from "recoil"
import DeleteAccount from "./DeleteAccountMobileLogin"
import DeleteAccountConfirmation from "./DeleteAccountMobileConfirmation"
import ClientInvitation from "./ClientInvitation"
import ClientInvitationSuccess from "./ClientInvitationSuccess"
import ExternalSSO from "./ExternalSSO"
import DashboardAccess from "./DashboardAccess"

const Routes: FC = () => {
  const { session } = useSession()
  const isOrgAdmin = useIsOrgAdmin()
  const loggingOut = useRecoilValue(loggingOutState)
  const setCurrentRiskAlertPath = useSetRecoilState(currentRiskAlertPathState)

  // We need to save the current risk alert path so that we can redirect back to it after the user logs in
  if (window.location.pathname.includes("risk-alert-detail")) {
    setCurrentRiskAlertPath(window.location.pathname)
  }

  // We're using ts-expect-error here because the types for react-router-dom are not fully compatible with the way we're using it.
  // We'll need to fix this but for now it's working correctly. We'll revisit this when we spend time updating the web app.
  return (
    // @ts-expect-error
    <BrowserRouter>
      {/* @ts-expect-error */}
      <Switch>
        {/* PUBLIC ROUTES */}
        {/* @ts-expect-error */}
        <Route exact path={ROUTES.LOGIN}>
          <Login />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.LOGGED_OUT}>
          <LoggedOut />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.REGISTER}>
          <Register />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.FORGOT_PASSWORD}>
          <ForgotPassword />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.FORGOT_PASSWORD_SUCCESS}>
          <ForgotPasswordSuccess />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.RESET_PASSWORD}>
          <ResetPassword />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.DELETE_ACCOUNT_LOGIN}>
          <DeleteAccount />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.DELETE_ACCOUNT_CONFIRMATION}>
          <DeleteAccountConfirmation />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.RESET_PASSWORD_SUCCESS}>
          <ResetPasswordSuccess />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.RESET_PASSWORD_SUCCESS_MOBILE}>
          <ResetPasswordSuccessMobile />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.CLIENT_INVITATION}>
          <ClientInvitation />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.CLIENT_INVITATION_SUCCESS}>
          <ClientInvitationSuccess />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.EXTERNAL_SSO}>
          <ExternalSSO />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.DASHBOARD_ACCESS}>
          <DashboardAccess />
        </Route>
        {/* PRIVATE ROUTES */}
        {session?.jwt && (
          <IdleLogout>
            <PrivateRoutes />
          </IdleLogout>
        )}
        {/* @ts-expect-error */}
        <Route path="*">
          {/* @ts-expect-error */}
          <Redirect
            to={
              !session?.jwt
                ? !loggingOut
                  ? ROUTES.LOGIN
                  : ROUTES.LOGGED_OUT
                : isOrgAdmin
                ? ROUTES.MY_ORG
                : ROUTES.MY_CLIENTS
            }
          />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
